import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import {fontSize, wh} from '../../mixins'
import { Logo } from '../../UI/Logo'
import { useDispatch, useSelector } from 'react-redux'
import { selectPlan, setDefaultPlanId } from './plansSlice'


export const StyledList = styled.ul`
    list-style: none;
    display: flex;
    justify-content: space-between;
    padding-bottom: 32px;
`;

export const StyledItem = styled.li`
    ${wh('76px')};
    background-color: ${({active}) => active ? '#F58A3C' : '#ffffff'};
    border: 1px solid #F58A3C;
    border-radius: 16px;
    text-align: center;
    color: ${({active}) => active ? '#ffffff' : '#323232'};
    font-weight: 700;
    ${fontSize(16)};
    line-height: 76px;
    position: relative;
    
    &:not(:last-child) {
        margin-right: 8px;
    }
    
    &:after {
        content: attr(data-text);
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
        color: #323232;
        display: block;
        position: absolute;
        top: calc(100% + 4px);
        left: 0;
    }
`;

const Title = styled.h1`
    font-weight: 700;
    ${fontSize(24)};
    line-height: 29px;
    text-align: center;
    color: #323232;
    margin: 20px 0 12px 0;
`;

const Description = styled.p`
    ${fontSize(16)};
    line-height: 19px;
    text-align: center;
    color: #323232;
    margin-bottom: 16px;
`;

const Cost = styled.div`
    background: #FFF1E7;
    font-weight: 500;
    padding: 16px;
    ${fontSize(14)};
    line-height: 17px;
    text-align: center;
    border-radius: 12px;
    color: #323232;
    margin-bottom: 16px;
`;

const TrialPlan = ({ handleSetPlan }) => {
    const { t } = useTranslation();
    const plan = useSelector(selectPlan);
    const dispatch = useDispatch();
    const TRIAL_PLANS = [
        {
            id: 'fm-2month-intro7d-1.00-69.99',
            price: '$1',
        },
        {
            id: 'fm-2month-intro7d-5.00-69.99',
            price: '$5',
        },
        {
            id: 'fm-2month-intro7d-10.00-69.99',
            price: '$10',
        },
        {
            id: 'fm-2month-intro7d-16.51-69.99',
            price: '$16.51',
            popular: true,
        },
    ];

    useEffect(() => {
        handleSetPlan(TRIAL_PLANS[3].id)
        dispatch(setDefaultPlanId(TRIAL_PLANS[3].id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const renderItem = (planInfo, index) => {
        const {id,price,popular} = planInfo;
        const isActive = (plan === id);

        return (
            <StyledItem key={index}
                        onClick={() => handleSetPlan(id)}
                        data-text={popular ? t('most_popular_choice') : ''}
                        isPopular={popular}
                        active={isActive}
                        id={'plan-button-'+(index+1)}
            >
                {price}
            </StyledItem>
        )
    };

    return (
        <>
            <Logo width={82} height={82} />
            <Title>{`${t('pay_what_you_want')}`}</Title>
            <Description>{t('pay_what_you_want_description')}</Description>
            <Cost>{t('it_cost_us', {price: TRIAL_PLANS[3].price})}</Cost>
            <StyledList>{TRIAL_PLANS.map(renderItem)}</StyledList>
        </>
    )
};

export default TrialPlan
